import * as React from "react";
import { ControlLabel } from "react-bootstrap";

interface LabelProps {}

export const Label: React.FC<LabelProps> = (props) => {
    return <ControlLabel>{props.children}</ControlLabel>;
};
